import React from 'react';
import Spinner from '@wix/wix-vod-shared/dist/src/widget/ui-components/loading-spinner/loading-spinner';
import { withStyles } from 'shared/utils/withStyles';
import styles from './mobile-spinner-overlay.styl';
var MobileSpinnerOverlay = function () { return (React.createElement("div", { className: styles['spinner-container'] },
    React.createElement(Spinner, { className: styles.spinner }))); };
export default withStyles(styles)(MobileSpinnerOverlay);
